/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { CardBody, Flex, Card } from "@chakra-ui/react";
import Loader from "../../../components/PageLoader";
import { useGetOpenTickets } from "../../../services/tickets";
import UpdateStatus from "./update-status";
import TicketsFilterBarV2 from "components/tickets/filter-bar";

export default function TicketsList() {
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({
    searchCriteria: "",
    period: "Today",
    cashCenterId: "",
    customerId: "",
    assetId: "",
  });
  const pageSize = 25;

  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
  } = useGetOpenTickets();

  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria || "",
      period: filters.period || "",
      cashCenterId: filters.cashCenterId || "",
      customerId: filters.customerId || "",
      assetId: filters.assetId || "",
    });
  }, [filters, reload]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(ticketsList.data.data);
    }
  }, [ticketsList]);
  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria || "",
      period: filters.period || "",
      cashCenterId: filters.cashCenterId || "",
      customerId: filters.customerId || "",
      assetId: filters.assetId || "",
    });
  };

  const updateCell = ({ dataItem }) => {
    return (
      <td>
        <div
          className="flex items-center justify-center w-full"
          title="Update Status"
        >
          <UpdateStatus
            onReload={() => {
              setReload(!reload);
            }}
            requestDetails={dataItem}
          />
        </div>
      </td>
    );
  };

  // console.log("dd", user.Roles.includes("Call Out Dispatcher"));
  return (
    <Flex className="main-container">
      {gettingTickets ? <Loader /> : <></>}
      <Card m="20px">
        <CardBody>
          <TicketsFilterBarV2
            getList={(
              filter,
              selectedDate,
              selectedCashCenter,
              selectedCustomer,
              selectedLocation
            ) => {
              setFilters({
                searchCriteria: filter,
                period: selectedDate,
                cashCenterId: selectedCashCenter,
                customerId: selectedCustomer,
                assetId: selectedLocation,
              });
            }}
          />

          <Grid
            data={tickets}
            className="list-tables-v1"
            filterable
            width="100%"
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            <GridColumn title="Case Number" width="170px" field="caseNo" />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />
            <GridColumn title="State" field="status" width="200px" />
            <GridColumn title="Region" field="state" width="150px" />
            <GridColumn title="Description" field="remarks" width="170px" />
            {/* <GridColumn
              title={"Assigned To"}
              field={"assignmentGroup"}
              width={"170px"}
            ></GridColumn> */}
            <GridColumn title="Priority" field="priority" width="170px" />
            <GridColumn
              title="Update"
              filterable={false}
              cell={updateCell}
              width="100px"
            />
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
